/**
 * Mention légale obligatoire lorsque le badge reCAPTCHA v3 est masqué en CSS.
 * @param {object} props
 * @param {string} [props.className] Classes additionnelles (alignement, marges).
 */
export default function RecaptchaLegalNotice({ className = '' }) {
  return (
    <p
      className={`text-[11px] text-gray-400 leading-snug ${className}`.trim()}
    >
      Ce site est protégé par reCAPTCHA.{' '}
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-gray-600"
      >
        Confidentialité
      </a>
      {' · '}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-gray-600"
      >
        Conditions
      </a>{' '}
      Google.
    </p>
  );
}
